<template>
  <b-modal v-if="users" v-model="active" :hide-footer="!footer" :title="title" centered size="lg">
    <h-f-global-search-field
      v-model="searchUsers"
      :base-url="userUrl"
      fields="uuid,first_name,last_name"
      placeholder="Rechercher des utilisateurs"
      ressource="users"
      style="position: relative; z-index: 1000"
    ></h-f-global-search-field>
    <div class="user-container-search">
      <div
        v-for="(user, index) in searchUsersFormated"
        :key="index"
        class="d-flex justify-content-between align-items-center mb-2"
      >
        <h-e-profile-default :first-name="user.first_name" :last-name="user.last_name" size="sm"></h-e-profile-default>
        <div>{{ user.first_name }} {{ user.last_name }}</div>
        <i class="mdi mdi-plus-circle-outline text-primary cursor-pointer" @click="addUser(index)"></i>
      </div>
    </div>
    <h5 class="mt-3">Utilisateurs associés :</h5>
    <div class="mt-3 px-4">
      <div
        v-for="(teamEntity, index) in team"
        :key="index"
        class="d-flex justify-content-between align-items-center mb-2"
      >
        <h-e-profile-default
          :first-name="teamEntity[`${entityName}_user_object`].first_name"
          :last-name="teamEntity[`${entityName}_user_object`].last_name"
          size="sm"
        ></h-e-profile-default>
        <div style="width: 17%">
          {{ teamEntity[`${entityName}_user_object`].first_name }}
          {{ teamEntity[`${entityName}_user_object`].last_name }}
        </div>
        <div class="d-flex justify-content-between">
          <h-f-fields
            v-for="(additionalField, indexx) in additionalFields"
            :key="indexx"
            v-model="teamEntity[additionalField.input]"
            v-bind="additionalField.options"
            :submitted="submitted"
            :invalid="$v.team.$each[index][additionalField.input].$error"
            :required="
              'required' in $v.team.$each[index][additionalField.input] &&
              !$v.team.$each[index][additionalField.input].required
            "
            :numeric="
              'numeric' in $v.team.$each[index][additionalField.input] &&
              !$v.team.$each[index][additionalField.input].numeric
            "
            :email="
              'email' in $v.team.$each[index][additionalField.input] &&
              !$v.team.$each[index][additionalField.input].email
            "
            :url="
              'url' in $v.team.$each[index][additionalField.input] && !$v.team.$each[index][additionalField.input].url
            "
            :min-length="
              'minLength' in $v.team.$each[index][additionalField.input] &&
              !$v.team.$each[index][additionalField.input].minLength
            "
            :max-length="
              'maxLength' in $v.team.$each[index][additionalField.input] &&
              !$v.team.$each[index][additionalField.input].maxLength
            "
            :decimal="
              'decimal' in $v.team.$each[index][additionalField.input] &&
              !$v.team.$each[index][additionalField.input].decimal
            "
            :min-value="
              'minValue' in $v.team.$each[index][additionalField.input] &&
              !$v.team.$each[index][additionalField.input].minValue
            "
            :max-value="
              'maxValue' in $v.team.$each[index][additionalField.input] &&
              !$v.team.$each[index][additionalField.input].maxValue
            "
            @input="editTeam(index)"
          />
        </div>
        <div class="d-flex justify-content-between" style="width: 40%">
          <h-b-action
            :positive="teamEntity.notification_bool"
            icon="mdi mdi-bell-ring-outline"
            text=""
            @click.native="changeNotification(index)"
          >
          </h-b-action>
          <h-b-action
            :positive="teamEntity.email_bool"
            icon="mdi mdi-email-outline"
            text=""
            @click.native="changeEmail(index)"
          >
          </h-b-action>
          <h-b-action :positive="true" icon="mdi mdi-delete-outline" text="Supprimer" @click.native="removeUser(index)">
          </h-b-action>
          <h-b-action
            v-if="manager"
            :positive="teamEntity.manager"
            color="success"
            icon="mdi mdi-account-group-outline"
            text="Manager"
            @click.native="changeManager(index)"
          >
          </h-b-action>
        </div>
      </div>
    </div>
    <template v-if="footer" #modal-footer>
      <div class="d-flex justify-content-end">
        <h-b-action :positive="true" text="Valider" @click.native="handleConfirm"></h-b-action>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { APIRequest, FunctionHelpers } from '@/node-sdk'

export default {
  name: 'user',

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    entity: {
      type: String,
      required: true,
    },
    entityName: {
      type: String,
      required: true,
    },
    masterEntityName: {
      type: String,
      default: '',
    }, // here for collaborator in project ...
    manager: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    limitToUsers: {
      type: Array,
      default: () => [],
    },
    footer: {
      type: Boolean,
      default: false,
    },
    needRequest: {
      type: Boolean,
      default: true,
    },
    additionalFields: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      users: [],
      active: false,
      userUrl: process.env.VUE_APP_API,
      searchUsers: [],
      team: this.value,
      searchUsersFormated: [],
      formatedUsers: [],
      submitted: true,
    }
  },

  validations() {
    const validation = {
      team: {
        $each: {},
      },
    }
    this.additionalFields.forEach((field) => {
      if (field.validations) {
        validation.team.$each[field.input] = field.validations
      }
    })
    return validation
  },

  watch: {
    searchUsers() {
      this.formatSearchUsers()
    },

    async value() {
      this.team = this.value
    },
  },

  methods: {
    async manageUserPop() {
      this.active = !this.active
      if (this.active) {
        await this.getUsers()
      }
    },

    async getUsers() {
      ;[this.users] = await APIRequest.get_with_request(process.env.VUE_APP_API, 'users', '')
    },

    formatSearchUsers() {
      this.searchUsersFormated = []
      const users = FunctionHelpers.formatSearchArray(this.searchUsers, this.team, 'uuid', `${this.entityName}_user`)
      if (this.limitToUsers.length !== 0) {
        for (let i = 0; i < users.length; i++) {
          if (this.limitToUsers.find((user) => user === users[i].uuid)) {
            this.searchUsersFormated.push(users[i])
          }
        }
      } else {
        this.searchUsersFormated = users
      }
    },

    async addUser(index) {
      const form = {
        notification_bool: false,
        email_bool: false,
        manager: false,
      }
      if (this.masterEntityName) {
        form[this.masterEntityName] = this.entity
      } else {
        form[this.entityName] = this.entity
      }
      form[`${this.entityName}_user`] = this.searchUsersFormated[index].uuid
      let teamEntity
      if (this.needRequest) {
        teamEntity = await APIRequest.create(this.url, `${this.entityName}-teams`, form)
        if (teamEntity) {
          this.$toast.open(FunctionHelpers.getMailSuccessOptions("à la personne ajoutée à l'équipe"))
        }
      } else {
        form[`${this.entityName}_user_object`] = this.users.find(
          (user) => user.uuid === this.searchUsersFormated[index].uuid,
        )
        teamEntity = form
      }
      this.team.push(teamEntity)
      this.$delete(this.searchUsersFormated, index)
    },

    async removeUser(index) {
      this.searchUsersFormated.push(
        this.users.find((user) => user.uuid === this.team[index][`${this.entityName}_user`]),
      )
      if (this.needRequest) {
        const response = await APIRequest.delete(this.url, `${this.entityName}-teams`, this.team[index].id)
        if (response) {
          this.$toast.open(FunctionHelpers.getMailSuccessOptions("à la personne retirée de l'équipe"))
        }
      }
      this.$delete(this.team, index)
    },

    async changeNotification(index) {
      this.team[index].notification_bool = !this.team[index].notification_bool
      await this.editTeam(index)
    },

    async changeEmail(index) {
      this.team[index].email_bool = !this.team[index].email_bool
      await this.editTeam(index)
    },

    async changeManager(index) {
      this.team[index].manager = !this.team[index].manager
      await this.editTeam(index)
    },

    async editTeam(index) {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if (this.needRequest) {
          await APIRequest.edit(this.url, `${this.entityName}-teams`, this.team[index].id, this.team[index])
        }
      }
    },

    handleConfirm() {
      this.$emit('confirm')
    },
  },
}
</script>

<style scoped>
.user-container-search {
  max-height: 200px;
  overflow: scroll;
  padding: 40px 30px 20px 30px;
  transform: translateY(-20px);
  display: block;
  z-index: 500;
  border-radius: 0 0 20px 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
</style>
